import { z } from 'zod';
import { ISO_DATE_PATTERN } from '@/common/utils/dateFormats';
import { compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
import { DEFAULT_GROUP_BY, GROUP_BY, type GroupBy } from '@/features/team-lens/types';
import { CUSTOM, MONTH, QUARTER, YEAR } from '@/features/teams/components/types';

const isoDateSearchParam = z.string().regex(ISO_DATE_PATTERN).optional().catch(undefined);

export const teamLensSearchSchema = z.object({
  period: z.enum([MONTH, QUARTER, YEAR, CUSTOM]).optional().default(MONTH).catch(MONTH),
  from: isoDateSearchParam,
  to: isoDateSearchParam,
  groupBy: z
    .enum([GROUP_BY.TEAMS, GROUP_BY.ROLE, GROUP_BY.SKILL])
    .optional()
    .default(DEFAULT_GROUP_BY)
    .catch(DEFAULT_GROUP_BY)
    .transform((value): GroupBy => (value === GROUP_BY.TEAMS ? value : DEFAULT_GROUP_BY)),
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  capacityCondition: compactPicklistFilterSchema,
  openRoleId: compactPicklistFilterSchema,
  openSkillId: compactPicklistFilterSchema,
});
